import React, { useState } from "react";
import { Button, Typography } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import "./Navbar.css";

const Navbar = ({ scrollToContact }) => {
  const [visible, setVisible] = useState(false);

  const toggleDropdown = () => {
    setVisible(!visible);
  };

  return (
    <nav className="navbar">
      <div className="logo">
      <Link to="/" className="logo-link">
          <Typography.Text className="logo-text">
            Cafe Hill Park
          </Typography.Text>
        </Link>
      </div>

      <div className="menu-desktop">
        <Link to="/menu" className="navbar-link">
          Menu
        </Link>
        <Link className="navbar-link" onClick={scrollToContact}>
          Contact & About
        </Link>
      </div>

      <div className="menu-mobile">
        <Button type="text" icon={<MenuOutlined />} onClick={toggleDropdown} />
        {visible && (
          <div className="small-dropdown">
            <Link
              className="dropdown-link"
              onClick={() => setVisible(false)}
            >
              Menu
            </Link>
            <Link
              className="dropdown-link"
              onClick={() => {
                scrollToContact();
                setVisible(false);
              }}
            >
              Contact & About
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
